import { render, staticRenderFns } from "./gzzoc-congenital-cataract-pdf.vue?vue&type=template&id=3cc81f10&scoped=true&lang=pug&"
import script from "./gzzoc-congenital-cataract-pdf.vue?vue&type=script&lang=js&"
export * from "./gzzoc-congenital-cataract-pdf.vue?vue&type=script&lang=js&"
import style0 from "./gzzoc-congenital-cataract-pdf.vue?vue&type=style&index=0&id=3cc81f10&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cc81f10",
  null
  
)

export default component.exports